// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "input[data-v-1144604e]::-webkit-outer-spin-button,\ninput[data-v-1144604e]::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\ninput[data-v-1144604e] {\n  text-indent: 3em;\n}\n", ""]);
// Exports
module.exports = exports;
